import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Receipt.css';
import type { ReceiptData } from '../api/types';

const Receipt: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const receipt: ReceiptData | undefined = location.state?.receipt;

  if (!receipt) {
    return (
      <div className="receipt-container">
        <h2 className="receipt-title">No receipt data found.</h2>
        <button className="receipt-btn" onClick={() => navigate('/')}>Go Home</button>
      </div>
    );
  }

  return (
    <div className="receipt-container">
      <div className="receipt-header">
        <h2 className="receipt-title">Thank You!</h2>
        <div className="receipt-success">Your payment was successful.</div>
        <div className="receipt-email">A receipt has been sent to <b>{receipt.customerEmail}</b>.</div>
      </div>
      <div className="receipt-details">
        <span>Name:</span> {receipt.customerName}<br />
        {receipt.date && <span>Date:</span>} {receipt.date}<br />
        {receipt.transactionId && <span>Transaction ID:</span>} {receipt.transactionId}
      </div>
      <h3 className="receipt-lineitems">Line Items</h3>
      <table className="receipt-table">
        <thead>
          <tr>
            <th>Item</th>
            <th className="quantity">Quantity</th>
            <th className="price">Price</th>
          </tr>
        </thead>
        <tbody>
          {receipt.items.map((item, idx) => (
            <tr key={idx}>
              <td>{item.name}</td>
              <td className="quantity">{item.quantity}</td>
              <td className="price">${item.price.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="receipt-total">
        {typeof receipt.subtotal === 'number' && (
          <div className="receipt-subtotal">Subtotal: ${receipt.subtotal.toFixed(2)}</div>
        )}
        {typeof receipt.tax === 'number' && (
          <div className="receipt-tax">Tax: ${receipt.tax.toFixed(2)}</div>
        )}
        <div>Total Paid: ${receipt.total.toFixed(2)}</div>
      </div>
      <div className="receipt-btn-container">
        <button className="receipt-btn" onClick={() => navigate('/')}>Go Home</button>
      </div>
    </div>
  );
};

export default Receipt;
